import { List, ListItem } from '@almbrand/list';
import { ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { PageContext } from 'context/PageContext';
import { useContext, useEffect, useState } from 'react';
import styles from './ListComponent.module.scss';

export const ListComponent = (props: StepBlock) => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext;

	const [listItems, setListItems] = useState<ListItem<ThemeUnion>[]>();
	const { fields } = props;

	useEffect(() => {
		let count = 0;
		const newListItems = fields.items.map((item) => {
			const content = item.content as ListItemBlock;

			return {
				...content,
				id: content.contentId,
				iconProp: {
					...content.icon,
					themeName: theme, // Set the themeName
				},

				alternateBullet: !content?.icon && <p className={styles.List__alternateBullet}>{++count}</p>,
			};
		});
		setListItems(newListItems as ListItem<ThemeUnion>[]);
	}, [props]);

	return listItems?.length && <List items={listItems} />;
};
